class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('submit', this.onSubmitHandler);

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', this.onKeyUpEscape);
    }
  }

  // Old code - auto search after clicking any filter
  // constructor() {
  //   super();
  //   this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

  //   this.debouncedOnSubmit = debounce((event) => {
  //     this.onSubmitHandler(event);
  //   }, 500);

  //   const facetForm = this.querySelector("form");
  //   facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

  //   const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
  //   if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  // }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) {
        return;
      }
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document
      .getElementById('ProductGridContainer')
      .querySelector('.collection')
      .classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(html.innerHTML);
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl)?.html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(html.innerHTML);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
    const productCountElement = parsedHtml.getElementById('ProductCount');

    if (productCountElement) {
      const count = productCountElement.innerHTML;
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');

      if (container) {
        container.innerHTML = count;
        container.classList.remove('loading');
      }

      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      // Check if the element with the specified selector exists
      const filterElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      if (filterElement) {
        filterElement.innerHTML = element.innerHTML;
      } else {
        // console.warning(
        //   `Element with data-index "${element.dataset.index}" not found.`
        // );
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) {
          newElementToActivate.focus();
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) {
        return;
      }
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) {
        return;
      }
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileFacet = document.getElementById('FacetFiltersFormMobile');

    if (mobileFacet) {
      mobileFacet.closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector('show-more-button .label-show-more.hidden')
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    window.history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    const negativeKeyword = formData.get('exq');
    const keywordValue = formData.getAll('q');

    // If there are multiple 'q' parameters, keep the last one
    if (keywordValue.length > 1) {
      const lastQ = keywordValue[keywordValue.length - 1];
      formData.delete('q');
      formData.append('q', lastQ);
    }

    if (negativeKeyword) {
      formData.append('q', `-${negativeKeyword}`);
    }

    const qKeyValue = formData.get('qkey');

    if (qKeyValue) {
      const pattern =
        /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{1,2}-[a-zA-Z0-9]{1,2}$/;
      let searchTitle = qKeyValue;
      if (qKeyValue.startsWith('"') && qKeyValue.endsWith('"')) {
        const inner = qKeyValue.slice(1, -1);
        if (pattern.test(inner)) {
          searchTitle = qKeyValue;
        }
      } else if (pattern.test(qKeyValue)) {
        searchTitle = `"${qKeyValue}"`;
      }
      formData.append('q', searchTitle);
    }
    // new avaibility
    if (formData.get('filter.v.availability') === '1') {
      // Remove any existing newState parameters first
      formData.delete('filter.p.m.attr.newState');
      // Add the required newState values for IN STOCK as separate parameters for OR logic
      formData.append('filter.p.m.attr.newState', 'all-others');
      formData.append('filter.p.m.attr.newState', 'new');
    }

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    const urlParams = new URLSearchParams(searchParams);
    const hasKeyword = urlParams.has('q') && urlParams.get('q');
    const hasExqKeyword = urlParams.has('exq') && urlParams.get('exq');

    if (window.location.pathname.includes('collection') && (hasKeyword || hasExqKeyword)) {
      const searchParamsString = searchParams ? `?${searchParams}` : '';

      sessionStorage.setItem('scrollToSortDesktop', 'true');

      if (brandIdValues.length > 0) {
        const brandIdParams = brandIdValues
          .map((id) => `filter.p.m.attr.mainBrand=${id}`)
          .join('&');
        window.location.href = `/search${searchParamsString}&${brandIdParams}`;
      } else {
        window.location.href = `/search${searchParamsString}`;
      }
    } else {
      sessionStorage.setItem('scrollToSortDesktop', 'true');
      FacetFiltersForm.renderPage(searchParams, event);
    }
    // FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className === 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm'
          ) {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }

    if (sessionStorage.getItem('scrollToSortDesktop') === 'true') {
      sessionStorage.removeItem('scrollToSortDesktop');
      const facetsWrapper = document.querySelector('.js-facets-desktop-wrapper');
      if (facetsWrapper) {
        facetsWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) {
      minInput.setAttribute('max', maxInput.value);
    }
    if (minInput.value) {
      maxInput.setAttribute('min', minInput.value);
    }
    if (minInput.value === '') {
      maxInput.setAttribute('min', 0);
    }
    if (maxInput.value === '') {
      minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) {
      input.value = min;
    }
    if (value > max) {
      input.value = max;
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (facetLink != null) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') {
          this.closeFilter(event);
        }
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Stock Filter Single Selection Logic - Simplified
function initStockFilter() {
  const inStock = document.getElementById('Filter-stock-in-stock');
  const comingSoon = document.getElementById('Filter-stock-coming-soon');

  if (!inStock || !comingSoon) {
    return;
  }

  // Remove existing listeners to prevent duplicates
  const existingInStockHandler = inStock.stockChangeHandler;
  const existingComingSoonHandler = comingSoon.stockChangeHandler;

  if (existingInStockHandler) {
    inStock.removeEventListener('change', existingInStockHandler);
  }
  if (existingComingSoonHandler) {
    comingSoon.removeEventListener('change', existingComingSoonHandler);
  }

  // Create new handlers
  const inStockHandler = function handleInStockChange() {
    if (this.checked && comingSoon.checked) {
      comingSoon.checked = false;
    }
  };

  const comingSoonHandler = function handleComingSoonChange() {
    if (this.checked && inStock.checked) {
      inStock.checked = false;
    }
  };

  // Store handlers on elements for later removal
  inStock.stockChangeHandler = inStockHandler;
  comingSoon.stockChangeHandler = comingSoonHandler;

  // Add new listeners
  inStock.addEventListener('change', inStockHandler);
  comingSoon.addEventListener('change', comingSoonHandler);
}

document.addEventListener('DOMContentLoaded', () => {
  initStockFilter();
});

// Re-initialize after AJAX updates
document.addEventListener('shopify:section:load', () => {
  setTimeout(initStockFilter, 100);
});

// Also handle other Shopify events that might update filters
const observer = new MutationObserver((mutations) => {
  let shouldReinit = false;
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (
            node.querySelector &&
            (node.querySelector('#Filter-stock-in-stock') ||
              node.querySelector('#Filter-stock-coming-soon') ||
              node.id === 'Filter-stock-in-stock' ||
              node.id === 'Filter-stock-coming-soon')
          ) {
            shouldReinit = true;
          }
        }
      });
    }
  });

  if (shouldReinit) {
    setTimeout(initStockFilter, 50);
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
